// extracted by mini-css-extract-plugin
module.exports = {"item":"page_item__V7gex","item__title":"page_item__title__MDY72"};